import React, { useState, useEffect } from 'react';
import classes from './SectionsSelector.module.css';
import apiGatewayService from '../../../common/services/apiGatewayService';
import localStorageService from '../../../common/services/localStorage.service';
import { CircularProgress, TextField, MenuItem, Select, Button, Box, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import utilityFunctions from '../../../common/services/utilityFunctions';
import ReactSelect from 'react-select';

const SectionsSelector = ({ isOpen, handleClose, submitOption }) => {
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedSectionDisplayName, setSelectedSectionDisplayName] = useState('');
  const [filter, setFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    // const sectionName = event.target.value?.sectionName;
    // const sectionDescription = event.target.value?.sectionDescription;
    // const selectOption = availableSections.find((option) => option.sectionName === sectionName &&  option.sectionDescription === sectionDescription);
    if (event!==null){
      const selectOption = availableSections.find((option) => option.sectionDisplayName === event.sectionDisplayName);
      setSelectedSection(selectOption);
      setSelectedSectionDisplayName(selectOption?.sectionDisplayName || '');
    } else {
      setSelectedSection(null);
      setSelectedSectionDisplayName('');
    }
  
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredSections = availableSections.filter((option) =>
    option.sectionDisplayName.toLowerCase().includes(filter.toLowerCase())
  );

  const handleSubmit = async () => {
    const section = selectedSection?.sectionId ? await getSectionById(selectedSection.sectionId) : undefined;
    submitOption(section);
    handleClose();
  };

  useEffect(() => {
    const getSections = async () => {
      setIsLoading(true);
      try {
        const response = await apiGatewayService.getSectionsData();
        const updatedSections = utilityFunctions.updateSectionNamesWithDescription(response.data);
        const updatedSectionsSorted = utilityFunctions.sortByKey(updatedSections, 'sectionDisplayName');
        const formattedSections = updatedSectionsSorted.map((section) => ({
          ...section,
          value: section.sectionDisplayName,
          label: section.sectionDisplayName,
        }));
        setAvailableSections(formattedSections);
      } catch (error) {
        console.error('Error fetching sections:', error);
      }
      setIsLoading(false);
    };
    getSections();
  }, []);

  const getSectionById = async (sectionId) => {
    try {
      setIsLoading(true);
      const response =  await apiGatewayService.getSectionsDataById(sectionId);
      console.log('Get section by Id response: ', response);
      setIsLoading(false);
      return response.data;
      // setCurrentSection(response.data);
    } catch(error) {
      setIsLoading(false);
      console.log('Error in getting sections: ', error);
    }
  };


  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="sections-selector-title" aria-describedby="sections-selector-description">
      <Box
        className={classes.ModalContainer}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
          width: '400px', // Adjust the width as needed
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <h3>Section Selector</h3>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '30px' }}>
            <CircularProgress sx={{ color: 'var(--app-color)' }} />
          </div>
        ) : (
          <div>
            {/* <TextField
              fullWidth
              variant="outlined"
              placeholder="Filter Section"
              value={filter}
              onChange={handleFilterChange}
              sx={{
                marginBottom: '16px',
                "& .MuiInputBase-root": {
                  height: 40,
                  backgroundColor: 'white',
                },
                "& .MuiOutlinedInput-input": {
                  height: 40,
                  width: '100%',
                },
              }}
            />
            <Select
              fullWidth
              value={selectedSectionDisplayName}
              onChange={handleChange}
              displayEmpty
              sx={{
                marginBottom: '16px',
                height: '40px',
                backgroundColor: 'white',
              }}
            >
              <MenuItem value="" disabled>
                <em>Select a section</em>
              </MenuItem>
              {filteredSections.map((option, index) => (
                <MenuItem key={index} value={option.sectionDisplayName}>
                  {option.sectionDisplayName}
                </MenuItem>
              ))}
            </Select> */}

          <ReactSelect
                value={selectedSection}
                onChange={handleChange}
                options={availableSections}
                placeholder="Select Section"
                isClearable
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    height: 40,
                    backgroundColor: 'white',
                    marginTop: '20px',
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 100,
                  }),
                }}
           />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{
                  mt: '20px',
                  backgroundColor: 'var(--button-color)',
                  color: 'white',
                  fontWeight: 'normal',
                  textTransform: 'none',
                  ":hover": {
                    backgroundColor: 'var(--button-hover-color)',
                  },
                }}
              >
                Submit
              </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default SectionsSelector;